import DatricRequests from '../datric.requests';
import { CreditTransaction } from '../../../models/credit.model';

const requests = new DatricRequests();

export async function getBalance(): Promise<{ balance: number }> {
	return requests.get('credits/balance');
}

export async function getStatement(): Promise<CreditTransaction[]> {
	return requests.get('credits/statement');
}
